import * as Cookies from "js-cookie";
import {EmbedStorage} from "./storage";
import {allowedProvider, Provider} from "../embed.provider";

export class EmbedCookieStorage implements EmbedStorage {
    private readonly cookieName = 'sso_user_allowed_embeds';
    private readonly consentLifetimeMonth = 12;

    private readonly domain: string;
    private readonly allowedProviders: readonly Provider[];
    private consentedProviders: Set<Provider>;

    constructor(allowedProviders: readonly Provider[]) {
        this.allowedProviders = allowedProviders;
        this.domain = location.host.substring(0, 4) === 'www.' ? location.host.substring(4) : location.host;
        this.consentedProviders = this.readCookie();
    }

    public providerHasConsent(provider: Provider): boolean {
        return this.consentedProviders.has(provider);
    }

    public setProviderConsent(provider: Provider, allowed: boolean) {
        if (!allowedProvider.includes(provider)) return;
        if (allowed) {
            this.consentedProviders.add(provider);
        } else {
            this.consentedProviders.delete(provider);
        }
        this.writeCookie();
    }

    public resetConsent() {
        this.consentedProviders.clear();
        this.writeCookie();
    }

    private readCookie(): Set<Provider> {
        const cookieValue = Cookies.get(this.cookieName) ?? '';
        return new Set(cookieValue
            .split(',')
            .map((provider) => provider as Provider)
            .filter((provider) => this.allowedProviders.includes(provider))
        );
    }

    private writeCookie() {
        if (this.consentedProviders.size === 0) {
            this.deleteCookie();
            return;
        }
        const cookieValue = [...this.consentedProviders].sort().join(',');
        const expires = new Date();
        expires.setMonth(expires.getMonth() + this.consentLifetimeMonth);
        Cookies.set(
            this.cookieName,
            cookieValue,
            {
                expires,
                path: '/',
                domain: this.domain,
                secure: true,
                sameSite: 'strict',
            },
        );
    }

    private deleteCookie() {
        Cookies.remove(this.cookieName, {domain: this.domain});
    }
}
